import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider } from 'react-intl'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import en from './lokalise/en.json'
import * as serviceWorker from './serviceWorker'
import LandingPage from './components/LandingPage'
import 'globalStyles'
import Hubspot from './Hubspot'

const messages = {
  en,
}

// at the moment it only supports 1 lang but it's prepared to support more in the future
const language = 'en'

const App = () => {
  window.heap.load(process.env.REACT_APP_HEAP_TOKEN)

  return (
    <IntlProvider locale={language} messages={messages[language]}>
      <Hubspot />
      <Router>
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Redirect to="/" />
        </Switch>
      </Router>
    </IntlProvider>
  )
}

export default App

const wrapper = document.getElementById('container')

// eslint-disable-next-line no-unused-expressions
wrapper ? ReactDOM.render(<App />, wrapper) : false

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
